<template>
  <div class="_d-flex _flex-1 _p-relative" v-if="showPlan && currentLevel">
    <div class="control-panel -top">
      <div>
        <!-- <label class="_m-b-1 _d-block">isPublic: {{ isPublicBooking }}</label> -->
        <label class="_m-b-1 _d-block">Select floor</label>
        <a-select v-model="currentLevelIndex" placeholder="Select Floor">
          <a-select-option
            v-for="(level, levelIndex) in currentEvent.levels"
            :key="`level-select-${level.id}`"
            :value="levelIndex"
          >{{ level.name }}</a-select-option>
        </a-select>
      </div>
    </div>

    <div class="map__wrapper">
      <div
        class="editor-tooltip"
        ref="tooltip"
        :style="{ position: 'fixed', left: `${tooltip.x}px`, top: `${tooltip.y}px`, display: tooltip.isVisible ? 'block' : 'none' }"
      >
        <div v-if="tooltip.data">ID: {{ tooltip.data.id }}</div>
      </div>

      <svg id="booking-editor" viewBox="0 0 500 500">
        <g class="booking-editor__viewport" id="booking-editor-viewport">
          <app-svg-shape
            v-for="shape in currentLevel.layout.data"
            :key="`shape-${shape.id}`"
            :shape="shape"
            @click="selectBooth(shape.id)"
            @mousemove.native="moveTooltip"
            @mouseleave.native="hideTooltip"
            @mouseenter.native="showTooltip(shape, $event)"
            :is-selected="selectedBooth == shape.id"
            :selectable="shape.layoutType == 'interactive'"
            :textValue="getTitleByBooth(shape.id)"
          ></app-svg-shape>
        </g>
      </svg>
    </div>

    <div class="properties__panel" v-if="isLoaded && selectedBooth && currentLevel">
      <h1
        class="title _m-b-1"
      >{{ currentProject.boothSettings.name }}: {{ currentLevel.schema.data[selectedBooth][currentProject.boothSettings.titleField] }}</h1>

      <div v-if="_user.isLoggedIn" class="_m-b-3">
        <a-button
          @click="viewRequests"
        >{{ currentBoothRequests }} Request{{ currentBoothRequests > 1 ? 's' : '' }}</a-button>
      </div>
      <!-- <a-modal
        title="Booking requests for this booth"
        :visible="isRequestsModalVisible"
        @cancel="closeRequests"
      >
        <div v-if="!_.isEmpty(requestsForBooth)">
          <a-card
            v-for="request in requestsForBooth"
            :key="request.id"
            :title="request.data[currentProject.boothSettings.titleFieldFromPublicData]"
          >
            <a href="#" slot="extra">more</a>
            <p class="_m-b-0" v-for="prop in currentProject.publicBoothProperties" :key="prop.id">
              <span class="_t-bold">{{ prop.label }}:</span>
              {{ request.data[prop.id] }}
            </p>
          </a-card>
        </div>
        <a-alert
          v-else
          message="No requests"
          description="Don't look at me, bitch!"
          type="info"
          showIcon
        />
      </a-modal>-->
      <div v-if="booking.id">
        <p>Booking-ID: {{ booking.id }}</p>
      </div>

      <app-property
        v-for="prop in currentProps"
        :key="`schema-property-${prop.id}`"
        :property="prop"
        :propertyData="workingPropData[prop.id] || null"
        @change="onPropertyChange(prop.id, $event)"
      ></app-property>
      <!-- <app-property
        v-for="prop in currentProps"
        :key="`schema-property-${prop.id}`"
        :property="prop"
        v-model="propertyData"
      ></app-property>-->
      <a-button
        v-if="!isPublicBooking"
        type="primary"
        class="_m-t-1"
        @click="saveBooking"
        block
        :loading="isLoading.saveBookingButton"
      >Save booking</a-button>
      <a-button
        v-else
        type="primary"
        class="_m-t-1"
        @click="sendRequest"
        block
        :loading="isLoading.saveBookingButton"
      >Send request</a-button>
    </div>

    <div class="requests-panel" v-show="isRequestsModalVisible">
      <a-button type="default" block size="small" @click="closeRequests" class="_m-b-3">Close</a-button>
      <div v-if="!_.isEmpty(requestsForBooth)">
        <a-card
          v-for="request in requestsForBooth"
          :key="request.id"
          :title="request.data[currentProject.boothSettings.titleFieldFromPublicData]"
        >
          <a href="#" slot="extra">more</a>
          <p class="_m-b-0" v-for="prop in currentProject.publicBoothProperties" :key="prop.id">
            <span class="_t-bold">{{ prop.label }}:</span>
            {{ request.data[prop.id] }}
          </p>
        </a-card>
      </div>
      <a-alert
        v-else
        message="No requests"
        description="Don't look at me, bitch!"
        type="info"
        showIcon
      />
    </div>
  </div>
</template>

<script>
import svgPanZoom from "svg-pan-zoom";
import AppSvgShape from "@/components/SvgShape";
import AppProperty from "@/components/Property";

export default {
  data() {
    return {
      panZoomPlan: null,
      ctm: null,
      eventId: this.$route.params.eventId,
      currentLevelIndex: 0,
      isLoaded: false,
      isMounted: false,

      isLoading: {
        saveBookingButton: false
      },

      booking: {
        data: {}
      },

      requestsForBooth: null,

      workspace: null,

      workingPropData: {},

      isRequestsModalVisible: false,

      tooltip: {
        x: 0,
        y: 0,
        isVisible: false,
        data: null
      }
    };
  },
  watch: {
    showPlan(value) {
      if (value) {
        this.$nextTick(() => {
          this.initPlanSVG();
          this.$nextTick(() => {
            if (this.$route.params.bookingId) {
              const booking = this.$store.state.booking.bookings[
                this.$route.params.bookingId
              ];
              const index = this.currentEvent.levels.findIndex(
                l => l.id == booking.levelId
              );
              this.currentLevelIndex = index;
              // console.log(booking);
              this.$nextTick(() => {
                this.selectBooth(booking.boothId);
              });
            }
          });
        });
      }
    },
    currentLevelIndex() {
      this.$store.commit("SELECT_BOOTH", null);
      this.$nextTick(() => {
        this.panZoomPlan.updateBBox();
        this.panZoomPlan.resize();
        this.panZoomPlan.fit();
        this.panZoomPlan.center();
        this.panZoomPlan.zoomBy(0.7);
      });
    }

    // selectedBooth: async function(value) {
    //   if (value) {
    //     this.booking = await this.$store.dispatch("booking/fetchByBooth", {
    //       boothId: value,
    //       eventId: this.currentEvent.id,
    //       levelId: this.currentLevel.id
    //     });
    //   }
    // }
  },
  methods: {
    /**
     * Tooltip
     */
    hideTooltip() {
      this.tooltip.isVisible = false;
    },
    showTooltip(shape, event) {
      if (shape.layoutType == "interactive") {
        let data = {
          id: shape.id
        };
        this.$set(this.tooltip, "data", data);
        this.tooltip.x = event.clientX + 20;
        this.tooltip.y = event.clientY - 20;
        this.tooltip.isVisible = true;
      }
    },
    moveTooltip(event) {
      this.tooltip.x = event.clientX + 20;
      this.tooltip.y = event.clientY - 20;
    },

    getTitleByBooth(id) {
      return (
        this.currentLevel &&
        this.currentProject &&
        this.currentLevel.schema.data[id] &&
        this.currentProject.boothSettings.titleField &&
        this.currentLevel.schema.data[id][
          this.currentProject.boothSettings.titleField
        ]
      );
    },

    onPropertyChange(id, value) {
      this.$log.info("[booking] -> property changed", id, value);
      this.$set(this.booking.data, id, value);
    },

    async viewRequests() {
      this.isRequestsModalVisible = true;
    },
    closeRequests() {
      this.isRequestsModalVisible = false;
    },

    async selectBooth(id) {
      this.$set(this, "booking", { data: {} });
      if (this.currentLevel.layout.data[id].layoutType == "interactive") {
        this.$store.commit("SELECT_BOOTH", id);

        if (!this.isPublicBooking) {
          const booking = this.$store.getters["booking/asArray"].find(b => {
            return (
              b.levelId == this.currentLevel.id &&
              b.boothId == this.selectedBooth
            );
          }) || {
            data: {}
          };

          this.$set(this, "requestsForBooth", null);
          const response = await this.axios.post(
            "/bookingRequest/byEventAndBooth",
            {
              eventId: this.currentEvent.id,
              boothId: id
            }
          );
          this.$set(this, "requestsForBooth", response.data.bookingRequests);

          this.workingPropData = _.cloneDeep(booking.data);

          this.$set(this, "booking", _.cloneDeep(booking));
        }
      }
    },
    initPlanSVG() {
      this.$log.info("[booking] -> init panZoom");
      const vm = this;
      var options = {
        viewportSelector: ".booking-editor__viewport",
        zoomEnabled: true,
        controlIconsEnabled: false,
        zoomScaleSensitivity: 0.5,
        minZoom: 0.25,
        maxZoom: 50,
        onUpdatedCTM: newCtm => {
          vm.ctm = newCtm;
        }
      };

      this.svg = document.getElementById("booking-editor");

      if (!this.svg) {
        this.$log.error("[booking] -> #booking-editor not found");
      }

      this.$log.info("[booking] -> #booking-editor found");

      this.panZoomPlan = svgPanZoom("#booking-editor", options);
      this.panZoomPlan.updateBBox();
      this.panZoomPlan.resize();
      this.panZoomPlan.fit();
      this.panZoomPlan.center();
      this.panZoomPlan.zoomBy(0.7);
      // this.panZoomPlan.updateBBox();
    },
    saveBooking() {
      this.isLoading.saveBookingButton = true;

      const action = this.booking.id ? "update" : "create";

      this.$store
        .dispatch(`booking/${action}`, {
          ...this.booking,
          eventId: this.eventId,
          levelId: this.currentLevel.id,
          boothId: this.selectedBooth
        })
        .then(booking => {
          this.$set(this, "booking", booking);
          this.isLoading.saveBookingButton = false;
        });
    },

    sendRequest() {
      this.isLoading.saveBookingButton = true;

      this.$store
        .dispatch(`bookingRequest/create`, {
          ...this.booking,
          eventId: this.eventId,
          levelId: this.currentLevel.id,
          boothId: this.selectedBooth,
          workspaceId: this.workspace.id
        })
        .then(booking => {
          // this.$set(this, "booking", booking);
          this.isLoading.saveBookingButton = false;
          this.$message.success(`Your request has been send!`);
        });
    }
  },
  computed: {
    // propertyData: {
    //   get() {

    //   },
    //   set() {

    //   }
    // },

    // currentLayout() {
    //   return this.currentLevel && this.currentLevel.layout.data;
    // },

    currentBoothRequests() {
      return this.requestsForBooth ? this.requestsForBooth.length : 0;
    },

    isPublicBooking() {
      return !!this.$route.meta.isPublicBooking;
    },

    currentProps() {
      if (this.isPublicBooking) {
        return this.isLoaded && this.currentProject.publicBoothProperties;
      } else {
        return this.isLoaded && this.currentProject.bookingBoothProperties;
      }
    },
    selectedBooth() {
      return this.$store.state.selectedBooth;
    },
    showPlan() {
      return this.isMounted && this.isLoaded;
    },
    currentEvent() {
      return this.isLoaded && this.$store.state.event.events[this.eventId];
    },
    currentLevel() {
      return (
        this.isLoaded &&
        this.currentEvent &&
        this.currentEvent.levels &&
        this.currentEvent.levels[this.currentLevelIndex]
      );
    },
    currentProject() {
      return (
        this.isLoaded &&
        this.currentEvent &&
        this.$store.state.project.projects[this.currentEvent.projectId]
      );
    }
  },
  mounted() {
    this.isMounted = true;
    // this.initPlanSVG();
  },
  async created() {
    this.$store.commit("SELECT_BOOTH", null);
    this.$store.commit("SET_IS_FETCHING", true);

    try {
      if (this.isPublicBooking) {
        const pathSplit = this.$route.params.eventId.split("-");
        this.eventId = pathSplit ? pathSplit[pathSplit.length - 1] : null;

        if (!this.eventId) {
          this.$router.replace("/404");
        }

        const workspaceResponse = await this.axios.post(
          `/public/workspace/getBySlug`,
          {
            slug: this.$route.params.workspaceSlug
          }
        );
        this.$set(this, "workspace", workspaceResponse.data.workspace);

        const event = await this.$store.dispatch("event/fetchSingle", {
          id: this.eventId,
          include: "levels.layout,levels.schema",
          isPublic: true
        });
        await this.$store.dispatch("project/fetchSingle", {
          id: event.projectId,
          isPublic: true
        });
        await this.$store.dispatch("booking/fetchAllByEvent", {
          eventId: this.eventId,
          isPublic: true
        });
      } else {
        await this.$store.dispatch("project/fetchAll");
        const event = await this.$store.dispatch("event/fetchSingle", {
          id: this.eventId,
          include: "levels.layout,levels.schema"
        });
        await this.$store.dispatch("booking/fetchAllByEvent", {
          eventId: this.eventId,
          isPublic: false
        });
      }
    } catch (e) {
      this.$router.replace("/404");
    }

    this.isLoaded = true;

    this.$store.commit("SET_IS_FETCHING", false);
  },
  destroyed() {
    this.$store.commit("SELECT_BOOTH", null);
  },
  components: {
    AppSvgShape,
    AppProperty
  }
};
</script>

<style lang="scss" scoped>
.map {
  &__wrapper {
    // height: 100vh;
    width: 100vw;
    overflow: hidden;
  }
}

#booking-editor {
  height: 100%;
  width: 100%;
}

.properties {
  &__panel {
    position: relative;
    // right: 0;
    // top: 0;
    // bottom: 0;
    padding: 30px;
    width: 400px;
    border-left: 1px solid $color-base-border;
  }
}

.requests-panel {
  width: 400px;
  padding: 30px;
  position: relative;

  border-left: 1px solid $color-base-border;
}

.control-panel {
  position: absolute;

  &.-top {
    top: 30px;
    left: 50%;
    transform: translate(-50%);
  }
}
</style>

